import axios from "axios";
import { API_BASE_URL } from "../config/env";
import store from "../store/AriStore";
import { startLoading, finishLoading } from "../reducer/loading";
import { openAlert } from "../reducer/alert";

const NewApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

NewApi.defaults.withCredentials = true;

NewApi.interceptors.request.use(
  function (config) {
    store.dispatch(startLoading());
    const token = sessionStorage.getItem("idToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  function (error) {
    store.dispatch(finishLoading());
    return Promise.reject(error);
  }
);

NewApi.interceptors.response.use(
  function (response) {
    store.dispatch(finishLoading());
    return response;
  },
  function (error) {
    store.dispatch(finishLoading());
    if (error.response) {
      if (error.response.status === 401) {
        store.dispatch(openAlert({ message: "인증이 만료되어 로그인 페이지로 이동합니다." }))
		window.location.href = "/";
      } else if (error.response.status === 403) {
        store.dispatch(openAlert({ message: "해당 요청을 실행할 권한이 부족합니다." }))
		window.location.href = "/";
      }
    }
    return error.response.data;
  }
);

export default NewApi;
